<div id="headerHeight" class="Headermargin">
  <div class="faq-page userhead">
    <!-- <nav class="navbar navbar-expand-md navbar-dark bg-dark">
      <div class="sectpad container-fluid">
        <a
          class="navbar-brand logomain getlogo"
          href="javascript:void(0)"
         
        >
          <img
          
            class="logo"
            height="33"
            src="https://res.cloudinary.com/honest-gorilla/image/upload/v1569491925/Static%20images/Logo/logotxt_wfug7a.svg"
            alt="Honest Gorilla logo in pink"
            title="Pink Honest Gorilla logo" />
          <img
          (click)="redirectToHome()"
            src="https://res.cloudinary.com/honest-gorilla/image/upload/v1569491925/Static%20images/Logo/logotxt_wfug7a.svg"
            alt="Honest Gorilla logo in pink"
            title="Pink Honest Gorilla logo"
            class="logo1"
        /></a>
        <button
        id="hidetxt"
          (click)="openNav($event)"
          class="navbar-toggler"
          type="button"
        
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <img
            src="assets/images/list.png"
            width="15"
            id="menuIcon"
            class="listicn"
          />
        </button>
        <div class="navbar-collapse collapse" id="navbarsExampleDefault">
          <ul class="navbar-nav mr-auto webnav text-left">
            <li class="nav-item active">
              <a
                class="nav-link"
                href="javascript:void(0)"
                routerLink="/commercial"
                >COMMERCIAL</a
              >
            </li>
            <li class="nav-item active">
              <a
                class="nav-link"
                href="javascript:void(0)"
                (click)="faqus()"
                routerLink="/faq"
                >FAQ</a
              >
            </li>
            <li class="nav-item active">
              <a class="nav-link" href="javascript:void(0)" routerLink="/blog"
                >BLOG</a
              >
            </li>
          </ul>
          <ul
            class="navbar-nav mr-auto webnav ml-auto"
            style="margin-right: 5px !important"
          >
            <li class="nav-item active">
              <a
                class="nav-link"
                href="javascript:void(0)"
                routerLink="/giveback"
                >GIVEBACK</a
              >
            </li>
            <li class="nav-item active">
              <a
                class="nav-link"
                href="javascript:void(0)"
                (click)="fcontactus()"
                routerLink="/faq/contact-us"
                >CONTACT US</a
              >
            </li>
            <li class="nav-item active">
              <a
                class="nav-link"
                href="javascript:void(0)" (click)="redirctCurrent()"
                style="border-bottom: 2px solid !important"
                >PROFILE</a
              >
            </li>
            <li class="nav-item active">
              <a class="nav-link" (click)="completeProcess()">SHOP NOW</a>
            </li>
          </ul>

          <div class="mobilenav sidenav">
            <div class="text-center">
              <h2 class="usermobhead semi-bold">{{ name }}</h2>
              <hr class="hrbdr" />
            </div>
            <div id="mySidebar" class="sidebar sidemenu x" (click)="closeNav()">
              <a
                href="javascript:void(0)"
                class="optn font-weight-bold-calibre"
                routerLink="/"
                >HOME
                <img
                  src="assets/images/home-rq.svg"
                  width="30"
                  class="float-right"
              /></a>
              <a
                href="javascript:void(0)"
                class="optn font-weight-bold-calibre"
                routerLink="/faq"
                >FAQ
                <img src="assets/images/faq-re.svg" width="30" class="float-right"
              /></a>
              <a
                href="javascript:void(0)"
                class="optn font-weight-bold-calibre"
                routerLink="/blog"
                >BLOG
                <img
                  src="assets/images/blog-re.svg"
                  width="30"
                  class="float-right"
              /></a>
              <a
                href="javascript:void(0)"
                class="optn font-weight-bold-calibre pr-4"
                style="line-height: 1.9 !important"
                routerLink="/giveback"
                >GIVEBACK
                <img
                  src="assets/images/giveback-re.svg"
                  width="27"
                  class="float-right"
              /></a>
              <a
                href="javascript:void(0)"
                class="optn font-weight-bold-calibre"
                routerLink="/faq/contact-us"
                >CONTACT US
                <img
                  src="assets/images/contactus-re.svg"
                  width="38"
                  class="float-right"
              /></a>
              <a  (click)="redirctCurrent()" href="javascript:void(0)" class="optn font-weight-bold-calibre"
                >PROFILE
                <img
                  src="assets/images/profile-icon-lightgray.svg"
                  width="34"
                  class="float-right"
                 
              /></a>
              <div class="text-center mb-5 pb-1 logoutbtn">
                <a
                  class="btn sectbtn col-6 brdrRadius" style="border-radius: 0.4rem !important "
                  href="javascript:void(0)"
                  (click)="logout()"
                  >LOGOUT</a
                >
              </div>
              <br />
              <div class="sidebar-ftr">
                <ul class="list-inline mb-5">
                  <li>
                    <a
                      class=""
                      href="https://www.facebook.com/honestgorilla1/"
                      target="_blank"
                      ><img src="assets/images/facebook.svg" width="30"
                    /></a>
                  </li>
                  <li>
                    <a
                      class=""
                      href="https://twitter.com/honestgorilla"
                      target="_blank"
                      ><img src="assets/images/twitter.svg" width="30"
                    /></a>
                  </li>
                  <li>
                    <a
                      class=""
                      href="https://www.instagram.com/honestgorilla_energy/ "
                      target="_blank"
                      ><img src="assets/images/instragram.svg" width="30"
                    /></a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <a
          class="btn sectbtn login ml-2 fntsize mb-2"
          href="javascript:void(0)"
          (click)="logout()"
          >LOGOUT</a
        >
      </div>
    </nav> -->

    <a  
    href="javascript:void(0)"
      (click)="logout()"
    class="btn sectbtn notibtn semi-bold mb-3 mt-1 mr-2  ng-star-inserted"  style="float: right !important; text-transform: uppercase !important">Logout
    </a>

    
    <a  
    href="javascript:void(0)"
      (click)="redirctCurrent()"
    class="btn sectbtn notibtn semi-bold mb-3 mr-2 mt-1 ng-star-inserted"  style="float: right !important; text-transform: uppercase !important">Profile
    </a>
  
   
    <a  
    href="javascript:void(0)"
      (click)="completeProcess()"
    class="btn sectbtn notibtn semi-bold mb-3 mr-2 mt-1 ng-star-inserted"  style="float: right !important; text-transform: uppercase !important">SHOP NOW
    </a>
    
  
  
 
  


  </div>
</div>
